import { z } from 'zod'

import { normalizePhone, removePhoneMask } from './normalizer'
import { PHONE_CONSTRAINTS, PHONE_REGEX } from './regex'

const digitsOnly = (value: string) => removePhoneMask(value).replace(/\D/g, '')

export const phoneSchema = z
	.string({ required_error: 'Укажите номер телефона' })
	.superRefine((value, ctx) => {
		const digits = digitsOnly(value)
		if (digits.length === 0) {
			ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Укажите номер телефона' })
			return
		}
		if (digits.length !== PHONE_CONSTRAINTS.DIGITS_LENGTH) {
			ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Введите полный номер телефона' })
			return
		}
		if (!PHONE_REGEX.test(normalizePhone(value))) {
			ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Укажите в формате +7 (9XX) XXX-XX-XX' })
		}
	})
	.transform(value => normalizePhone(value))

export const phoneSchemaOptional = z
	.union([z.string(), z.undefined(), z.null()])
	.transform(value => (value === '' || value == null ? null : value))
	.superRefine((value, ctx) => {
		if (value == null) return
		const digits = digitsOnly(value)
		if (digits.length === 0) {
			ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Укажите номер телефона' })
			return
		}
		if (digits.length !== PHONE_CONSTRAINTS.DIGITS_LENGTH) {
			ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Введите полный номер телефона' })
			return
		}
		if (!PHONE_REGEX.test(normalizePhone(value))) {
			ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Укажите в формате +7 (9XX) XXX-XX-XX' })
		}
	})
	.transform(value => (value ? normalizePhone(value) : null))
